import TipsAndUpdatesRoundedIcon from "@mui/icons-material/TipsAndUpdatesRounded";
import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";
import { usePagesTranslation } from "../../../../pages/locales";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { HINT_POINT_COST, HINT_POINTS_PACK_AMOUNT } from "../lib/hintPointsConstants";
import {
    PLAY_TOOLBAR_BTN_SIZE,
    PLAY_TOOLBAR_ICON_SIZE,
    playToolbarHintBadgeSx,
    playToolbarHintPillSx,
} from "../styles/playToolbarStyles";

/**
 * Toolbar hint control — circular glass chip + amber coin badge (Android PlayToolbar).
 * Spends {@link HINT_POINT_COST} coins per ghost guide.
 */
export default function GhostGuideHintButton({
    pointBalance = 0,
    disabled = false,
    active = false,
    onActivate = null,
    glass = null,
    size = PLAY_TOOLBAR_BTN_SIZE,
    iconSize = PLAY_TOOLBAR_ICON_SIZE,
}) {
    const { t } = usePagesTranslation();
    const { tokens } = useSlidingAppearance();
    const canAfford = pointBalance >= HINT_POINT_COST;
    const isDisabled = disabled || !onActivate;
    const large = size > PLAY_TOOLBAR_BTN_SIZE;
    const label = canAfford
        ? t("native.sliding.play.ghostGuideHint", {
              defaultValue: "Hint ({{cost}} coins) — {{count}} left",
              cost: HINT_POINT_COST,
              count: pointBalance,
          })
        : t("native.sliding.play.ghostGuideHintEmpty", {
              defaultValue: "No assistant coins — get {{amount}} for $1.99",
              amount: HINT_POINTS_PACK_AMOUNT,
          });

    return (
        <Tooltip title={label}>
            <Box component="span" sx={{ display: "inline-flex", flexShrink: 0, position: "relative" }}>
                <Box
                    component="button"
                    type="button"
                    aria-label={label}
                    aria-busy={active}
                    aria-disabled={isDisabled}
                    disabled={isDisabled}
                    onClick={isDisabled ? undefined : onActivate}
                    sx={playToolbarHintPillSx(tokens, {
                        active,
                        disabled: isDisabled,
                        glass,
                        size,
                    })}
                >
                    <TipsAndUpdatesRoundedIcon
                        sx={{
                            fontSize: iconSize,
                            display: "block",
                            flexShrink: 0,
                        }}
                    />
                </Box>
                <Typography component="span" aria-hidden sx={playToolbarHintBadgeSx({ large })}>
                    {pointBalance}
                </Typography>
            </Box>
        </Tooltip>
    );
}
